(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("teamapps", [], factory);
	else if(typeof exports === 'object')
		exports["teamapps"] = factory();
	else
		root["teamapps"] = factory();
})(window, function() {
return 